/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <g>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 5.4V0H0v24h24V7l-8-1.6ZM14 2H9v6h5V2Zm2 5.4396V22h6V8.6396l-6-1.2ZM14 22v-5H9v5h5Zm0-7v-5H9v5h5ZM7 2v6H2V2h5Zm0 13H2v-5h5v5Zm0 2H2v5h5v-5Z"
      clipRule="evenodd"
    />
  </g>,
  'Organization'
);
